/**
 * Recurring class booking prompt.
 *
 * Shown in the Book a Lesson modal right after a student picks a slot and
 * presses Book. Nothing is actually booked recurringly — the prompt exists
 * to measure how many students would want it before it's built, so it is
 * kept behind this flag rather than always on.
 */

/** PostHog multivariate flag. */
export const RECURRING_BOOKING_FEATURE_FLAG = 'recurring-booking-new';

export const RECURRING_BOOKING_VARIANTS = {
  CONTROL: 'control',
  TEST: 'test',
} as const;
